import { PromoCarousel } from '@ahc-digital/component-library';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PROMO_CAROUSEL_CTAS } from 'src/shared/static';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { GetPromoCarouselModel } from './C06PromoCarouselCTA.service';
import { C06PromoCarouselCTAProps } from './C06PromoCarouselCTA.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C06PromoCarouselCTAProps): JSX.Element => {
  const phKey = PROMO_CAROUSEL_CTAS.replace('{*}', props?.params?.DynamicPlaceholderId || '');
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <div>{props?.rendering && <Placeholder name={phKey} rendering={props.rendering} />}</div>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <PromoCarousel
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetPromoCarouselModel(props)}
    />
  );
};
